export const GET_CREDIT_CARD_LIST_START =
  'GET_CREDIT_CARD_LIST_START';
export const GET_CREDIT_CARD_LIST_SUCCESS =
  'GET_CREDIT_CARD_LIST_SUCCESS';
export const GET_CREDIT_CARD_LIST_ERROR =
  'GET_CREDIT_CARD_LIST_ERROR';
export const GET_CREDIT_CARD_LIST_END = 'GET_CREDIT_CARD_LIST_END';
